import { IProjectSpaceTypeCategory } from 'spw-redux/modules/projects/types';
import { useMemo } from 'react';
import { uniqueRow } from 'spw-components/worksheet/utils';
import _ from 'lodash';
import WorksheetRow from '../../../../../models/WorksheetRow';
import { PlainWorksheet } from '../../../../../models/Worksheet';

export const useWorksheetRowsByCategory = (
  projectSpaceTypeCategory: IProjectSpaceTypeCategory,
  worksheet: PlainWorksheet,
  open: boolean
) => {
  const { category } = projectSpaceTypeCategory.defaultSpaceTypeCategory;

  const { categoryRows, hasRowsBelongingToASubcategory } = useMemo(() => {
    const rowsByCategory = _(worksheet?.rowsByCategory?.[category])
      .filter(
        (row: WorksheetRow) =>
          ((!open && !row.child) || open) && !row.removed && !row.subcategory
      )
      .uniqBy(uniqueRow)
      .value();

    return {
      categoryRows: rowsByCategory,
      hasRowsBelongingToASubcategory: Object.keys(
        worksheet.rowsBySubcategory
      )?.some(
        (subcategory) => worksheet.rowsBySubcategory[subcategory]?.length > 0
      ),
    };
  }, [category, worksheet?.rowsByCategory, worksheet?.rowsBySubcategory, open]);

  return {
    categoryRows,
    hasRowsBelongingToASubcategory,
  };
};
